import React from 'react';
import { motion } from 'framer-motion';
import { Question } from '../data/questions';
type QuizQuestionProps = {
  question: Question;
  selected?: string;
  onSelect: (value: string) => void;
};
export function QuizQuestion({
  question,
  selected,
  onSelect
}: QuizQuestionProps) {
  return <div data-id="element-80" data-mp="3m0wu8n9repw5">
      <motion.h2 initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }} className="font-serif text-3xl font-light leading-tight text-warmgray-800 sm:text-4xl" data-id="element-81" data-mp="3m1okrjoi1xfk">
        {question.title}
      </motion.h2>

      {question.note && <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.7,
      delay: 0.1
    }} className="mt-4 text-sm font-light text-warmgray-500" data-id="element-82" data-mp="3w39a9i5pqti">
          {question.note}
        </motion.p>}

      <div className="mt-10 flex flex-col gap-3" role="radiogroup" aria-label={question.title} data-id="element-83" data-mp="2al863skrrktr">
        {question.options.map((option, index) => {
        const isSelected = selected === option.value;
        return <motion.button key={option.value} type="button" role="radio" aria-checked={isSelected} onClick={() => onSelect(option.value)} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.08 + index * 0.06,
          ease: [0.22, 1, 0.36, 1]
        }} className={`group flex w-full items-center gap-4 rounded-2xl border px-6 py-5 text-left transition-all duration-500 ease-calm ${isSelected ? 'border-sage-500 bg-sage-50' : 'border-beige-300 bg-white hover:border-sage-300 hover:bg-beige-50'}`} data-id="element-84" data-mp="l742eg133j2q" data-mpi={index}>
              <span aria-hidden="true" className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border transition-colors duration-500 ${isSelected ? 'border-sage-600' : 'border-warmgray-400/60'}`} data-id="element-85" data-mp="3frbvut8qsku0">
                <span className={`h-1.5 w-1.5 rounded-full bg-sage-600 transition-opacity duration-500 ${isSelected ? 'opacity-100' : 'opacity-0'}`} data-id="element-86" data-mp="387su55rpy2w3" />
              </span>
              <span className="text-base font-light text-warmgray-800" data-id="element-87" data-mp="337ey6m3e6jef">
                {option.label}
              </span>
            </motion.button>;
      })}
      </div>
    </div>;
}